const MESSAGE_CONSTANT = {
	INVALID_DETAILS: 'Invalid Details Provided.',
	SOMETHING_WRONG: 'Something went wrong!!!',
	RESEND_OTP_SUCCESS: 'OTP sent successfully',
};
export default MESSAGE_CONSTANT;
